<template>
  <div
    id="app"
    :style="{
       'background-color': project && project.backgroundColor ? project.backgroundColor : '#000',
     }"
  >
    <router-view/>
  </div>
</template>
<script>
// Keep shell styling scoped to the exact aliases used by Home and Quotes.
function normalizeDomain(value) {
  return String(value || '').trim().toLowerCase()
    .replace(/^https?:\/\//, '')
    .split('/')[0].replace(/\.$/, '').replace(/^www\./, '');
}

export default {
  data() {
    return {
      project: {
        backgroundColor: '#000',
      },
      projectDomain: '',
    };
  },
  methods: {
    getProject() {
      const domain = normalizeDomain(this.projectDomain);
      if (!domain) return;
      this.axios.get(`${this.$API}/projects?domain_contains=${encodeURIComponent(domain)}`).then((response) => {
        const projects = Array.isArray(response.data) ? response.data : [];
        const matches = projects.filter(project => project && String(project.domain || '')
          .split(',').some(alias => normalizeDomain(alias) === domain));
        if (matches.length === 1 && matches[0].id) {
          [this.project] = matches;
        }
      }).catch((error) => {
        console.error('Error fetching project:', error);
        // Keep the default background; never fall back to another host's project.
      });
    },
  },
  created() {
    this.projectDomain = normalizeDomain(window.location.host);
    this.getProject();
    // Vue's editor is statically registered at /manage; /admin belongs to the CMS.
  },
};
</script>
<style lang="scss">
html,
body,
#app {
  background-color: #000;
  // overflow: hidden;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow-y: hidden !important;
  color: #2c3e50;
}
</style>
